import { KeyValuePair } from "./../types/KeyValuePair";
// Date formats
export const dateFormats: KeyValuePair<string>[] = [
  { key: "ISO8601", value: "2023-04-15T14:32:17Z" },
  { key: "RFC2822", value: "Wed, 15 Apr 2023 14:32:17 +0000" },
  { key: "yyyy-MM-dd", value: "2023-04-15" },
  { key: "MM/dd/yyyy", value: "04/15/2023" },
  { key: "dd/MM/yyyy", value: "15/04/2023" },
  { key: "yyyy/MM/dd", value: "2023/04/15" },
  { key: "dd-MMM-yyyy", value: "15-Apr-2023" },
  { key: "MMM dd, yyyy", value: "Apr 15, 2023" },
  { key: "yyyy-MM-dd HH:mm:ss", value: "2023-04-15 14:32:17" },
  { key: "yyyy-MM-dd hh:mm:ss tt", value: "2023-04-15 02:32:17 PM" },
  { key: "MM/dd/yyyy hh:mm tt", value: "04/15/2023 02:32 PM" },
];
